import { getItemOrDefaultToValue, getPersonName } from 'utils/details';
import { convertTime, displayTime } from 'utils/time';
import {
  BASE_TRIP_STATUS,
  BASE_TRANSPORT_TYPE,
} from 'utils/constants/transport';
import { DEFAULT_EMPTY_VALUE } from 'utils/constants';

const getTripSummaryData = plannedRoute => {
  const data = [];
  data.push({
    label: `${convertTime(plannedRoute.pickUpLocation.timestamp, 'HH:mm')} : ${
      plannedRoute.pickUpLocation.address
    }`,
    content: '',
  });
  //eslint-disable-next-line
  plannedRoute.route.map(route => {
    if (route.address) {
      // if address is empty hide
      return data.push({
        label: `${convertTime(route.timestamp, 'HH:mm')} : ${route.address ??
          'No Address'}`,
        content: '',
      });
    }
  });
  return data;
};

const getStatusAudit = statusAudit => {
  const statusProgress = statusAudit.map(data => ({
    display: `${BASE_TRIP_STATUS[data.status].value} : ${convertTime(
      data.timestamp,
      'HH:mm',
    )}`,
  }));
  return statusProgress.reverse();
};

export const transformTripDetail = (tripDetail, timeZone) => {
  return {
    generalInfo: {
      tripId: {
        type: 'text',
        value: getItemOrDefaultToValue(
          tripDetail,
          'tripId',
          DEFAULT_EMPTY_VALUE,
        ),
      },
      lastUpdatedAt: {
        type: 'text',
        value: displayTime({
          timestamp: getItemOrDefaultToValue(
            tripDetail,
            'currentStatusTimestamp',
          ),
          timeZone,
        }),
      },
      riskLevel: {
        type: 'text',
        value: tripDetail.riskLevel
          ? getItemOrDefaultToValue(
              tripDetail,
              'riskLevel',
              DEFAULT_EMPTY_VALUE,
            ) // API is not giving this data currently
          : DEFAULT_EMPTY_VALUE,
      },
      status: {
        type: 'icon-with-label',
        value: BASE_TRIP_STATUS[tripDetail.currentStatus],
      },
    },
    detailedInfo: {
      tripSummary: {
        type: 'trip-locations',
        value: getTripSummaryData(tripDetail.plannedRoute),
      },

      pickUpTime: {
        type: 'text',
        value: displayTime({
          timestamp: tripDetail.pickUpTime,
          timeZone,
        }),
      },
      destinationTime: {
        type: 'text',
        value: displayTime({
          timestamp: tripDetail.destinationTime,
          timeZone,
        }),
      },
      tripType: {
        type: 'text',
        // value: getItemOrDefaultToValue(tripDetail.tripType, 'serviceType', DEFAULT_EMPTY_VALUE),
        value: tripDetail.tripType
          ? BASE_TRANSPORT_TYPE[tripDetail.tripType.serviceType].value
          : DEFAULT_EMPTY_VALUE,
      },
      vehicleType: {
        type: 'text',
        value: tripDetail.tripType
          ? getItemOrDefaultToValue(
              tripDetail.tripType,
              'vehicleType',
              DEFAULT_EMPTY_VALUE,
            )
          : DEFAULT_EMPTY_VALUE,
      },
      options: {
        type: 'text',
        value: DEFAULT_EMPTY_VALUE, //assigning DEFAULT_EMPTY_VALUE as in the UI design the value is crossed out
      },
      noteToDriver: {
        type: 'text',
        value: tripDetail.tripOptions
          ? getItemOrDefaultToValue(
              tripDetail.tripOptions,
              'noteToDriver',
              DEFAULT_EMPTY_VALUE,
            )
          : DEFAULT_EMPTY_VALUE,
      },
      estimatedPrice: {
        type: 'text',
        value: tripDetail.tripType.estimatedPrice
          ? getItemOrDefaultToValue(
              tripDetail.tripType,
              'estimatedPrice',
              DEFAULT_EMPTY_VALUE,
            )
          : DEFAULT_EMPTY_VALUE,
      },
      actualPrice: {
        type: 'text',
        value: tripDetail.actualPrice
          ? getItemOrDefaultToValue(
              tripDetail,
              'actualPrice',
              DEFAULT_EMPTY_VALUE,
            ) // API is not giving this data currently
          : DEFAULT_EMPTY_VALUE,
      },
      tripProgress: {
        type: 'array',
        value: getStatusAudit(
          getItemOrDefaultToValue(tripDetail, 'statusAudit'),
        ),
      },
    },
    others: {
      detailedInfoImage: {
        value: getItemOrDefaultToValue(
          tripDetail.passenger.user.general,
          'photoUrl',
        ),
      },
      id: {
        value: tripDetail.id,
      },
      passengerLocation: {
        value: tripDetail.plannedRoute
          ? getItemOrDefaultToValue(
              tripDetail.plannedRoute.pickUpLocation,
              'point',
            )
          : {},
      },
      driverLocation: tripDetail.driver != null && {
        value: getItemOrDefaultToValue(
          tripDetail.driver.user.operational.location,
          'point',
        ),
      },
    },
    detailedGeneralInfo: {
      name: {
        type: 'text',
        value: getPersonName(tripDetail.passenger.user.general),
      },
      customerPhone: {
        type: 'text',
        value:
          tripDetail.passenger.user.general.phoneNumber !== null
            ? `${getItemOrDefaultToValue(
                tripDetail.passenger.user.general.phoneNumber,
                'prefix',
              )} ${getItemOrDefaultToValue(
                tripDetail.passenger.user.general.phoneNumber,
                'number',
                DEFAULT_EMPTY_VALUE,
              )}`
            : DEFAULT_EMPTY_VALUE,
      },
      customerEmail: {
        type: 'text',
        value: getItemOrDefaultToValue(
          tripDetail.passenger.user.general,
          'email',
          DEFAULT_EMPTY_VALUE,
        ),
      },
      verified: {
        type: 'text',
        value: tripDetail.passenger.user.details.verifications.idVerified
          ? getItemOrDefaultToValue(
              tripDetail.passenger.user.details.verifications,
              'idVerified',
              DEFAULT_EMPTY_VALUE,
            )
          : DEFAULT_EMPTY_VALUE,
      },
      businessClient: {
        type: 'text',
        value: getItemOrDefaultToValue(
          tripDetail.passenger.user.general,
          'businessClientName',
          DEFAULT_EMPTY_VALUE,
        ),
      },
    },
  };
};
